// extracted by mini-css-extract-plugin
export default {"sender":"MailHeader_sender__6zuox"};